import CITIES from "./seoCities.json";

export const LANGS4 = ["de", "en", "fr", "it"];

export const SEO_IMAGES = {
  city: "https://static.prod-images.emergentagent.com/jobs/962c22e3-0970-4f4f-87ee-1d8774a26496/images/141f4c5964ce79e663017e1f8bd823400ca9a6cb226c17a0015cad462e4f5483.jpeg",
  town: "https://static.prod-images.emergentagent.com/jobs/962c22e3-0970-4f4f-87ee-1d8774a26496/images/141f4c5964ce79e663017e1f8bd823400ca9a6cb226c17a0015cad462e4f5483.jpeg",
  lake: "https://static.prod-images.emergentagent.com/jobs/962c22e3-0970-4f4f-87ee-1d8774a26496/images/acfeee7de8066c16a5db2786d91d4fb2c5df7267ca93b3f2fa6c2a238a0f1405.jpeg",
  mountain: "https://static.prod-images.emergentagent.com/jobs/962c22e3-0970-4f4f-87ee-1d8774a26496/images/b7b94a0b0f80b0e209ce983f2c4e950a71df326e1d480c8be6f6d249b50083a6.jpeg",
  business: "https://static.prod-images.emergentagent.com/jobs/962c22e3-0970-4f4f-87ee-1d8774a26496/images/e70a5d020a12fcf8e5229f7c12e649eb9665307f06e8a095b2bed4bc19eddd2a.jpeg",
};

// Each pattern targets one keyword phrasing. kw uses {c} (city name), slug uses {s} (city slug).
export const PATTERNS = [
  { id: "transfer", de: ["Flughafentransfer Zürich {c}", "flughafentransfer-zuerich-{s}"], en: ["Zurich Airport Transfer to {c}", "zurich-airport-transfer-{s}"], fr: ["Transfert Aéroport Zurich {c}", "transfert-aeroport-zurich-{s}"], it: ["Trasferimento Aeroporto Zurigo {c}", "trasferimento-aeroporto-zurigo-{s}"] },
  { id: "taxi-a2c", de: ["Taxi Flughafen Zürich nach {c}", "taxi-flughafen-zuerich-nach-{s}"], en: ["Taxi from Zurich Airport to {c}", "taxi-zurich-airport-to-{s}"], fr: ["Taxi Aéroport Zurich vers {c}", "taxi-aeroport-zurich-vers-{s}"], it: ["Taxi Aeroporto Zurigo per {c}", "taxi-aeroporto-zurigo-per-{s}"] },
  { id: "taxi-c2a", de: ["Taxi {c} zum Flughafen Zürich", "taxi-{s}-flughafen-zuerich"], en: ["Taxi {c} to Zurich Airport", "taxi-{s}-to-zurich-airport"], fr: ["Taxi {c} vers l'aéroport de Zurich", "taxi-{s}-aeroport-zurich"], it: ["Taxi {c} per l'aeroporto di Zurigo", "taxi-{s}-aeroporto-zurigo"] },
  { id: "flughafentaxi", de: ["Flughafentaxi {c}", "flughafentaxi-{s}"], en: ["{c} Airport Taxi", "{s}-airport-taxi"], fr: ["Taxi aéroport {c}", "taxi-aeroport-{s}"], it: ["Taxi aeroporto {c}", "taxi-aeroporto-{s}"] },
  { id: "city-taxi", de: ["{c} Taxi", "{s}-taxi"], en: ["{c} Taxi Service", "{s}-taxi-service"], fr: ["{c} Taxi", "{s}-taxi"], it: ["{c} Taxi", "{s}-taxi"] },
  { id: "airport-to-city", de: ["Flughafen nach {c} Taxi", "flughafen-nach-{s}-taxi"], en: ["Airport to {c} Taxi", "airport-to-{s}-taxi"], fr: ["Aéroport vers {c} taxi", "aeroport-vers-{s}-taxi"], it: ["Aeroporto per {c} taxi", "aeroporto-per-{s}-taxi"] },
  { id: "transfer-from", de: ["Transfer Flughafen Zürich {c}", "transfer-flughafen-zuerich-{s}"], en: ["Transfer from Zurich Airport to {c}", "transfer-from-zurich-airport-{s}"], fr: ["Transfert depuis l'aéroport de Zurich {c}", "transfert-depuis-aeroport-zurich-{s}"], it: ["Transfer dall'aeroporto di Zurigo {c}", "transfer-aeroporto-zurigo-{s}"] },
  { id: "private", de: ["Privattransfer Zürich {c}", "privattransfer-zuerich-{s}"], en: ["Private Transfer Zurich Airport {c}", "private-transfer-zurich-{s}"], fr: ["Transfert privé Zurich {c}", "transfert-prive-zurich-{s}"], it: ["Transfer privato Zurigo {c}", "transfer-privato-zurigo-{s}"] },
  { id: "shuttle", de: ["Flughafen Shuttle Zürich {c}", "flughafen-shuttle-zuerich-{s}"], en: ["Zurich Airport Shuttle {c}", "zurich-airport-shuttle-{s}"], fr: ["Navette aéroport Zurich {c}", "navette-aeroport-zurich-{s}"], it: ["Navetta aeroporto Zurigo {c}", "navetta-aeroporto-zurigo-{s}"] },
  { id: "price", de: ["Taxi Preis Flughafen Zürich {c}", "taxi-preis-flughafen-zuerich-{s}"], en: ["Taxi Price Zurich Airport to {c}", "taxi-price-zurich-airport-{s}"], fr: ["Prix taxi aéroport Zurich {c}", "prix-taxi-aeroport-zurich-{s}"], it: ["Prezzo taxi aeroporto Zurigo {c}", "prezzo-taxi-aeroporto-zurigo-{s}"] },
  { id: "limousine", de: ["Limousinenservice Zürich {c}", "limousinenservice-zuerich-{s}"], en: ["Limousine Service Zurich {c}", "limousine-service-zurich-{s}"], fr: ["Service de limousine Zurich {c}", "service-limousine-zurich-{s}"], it: ["Servizio limousine Zurigo {c}", "servizio-limousine-zurigo-{s}"] },
  { id: "vip", de: ["VIP Transfer Zürich {c}", "vip-transfer-zuerich-{s}"], en: ["VIP Transfer Zurich {c}", "vip-transfer-zurich-{s}"], fr: ["Transfert VIP Zurich {c}", "transfert-vip-zurich-{s}"], it: ["Transfer VIP Zurigo {c}", "transfer-vip-zurigo-{s}"] },
  { id: "cheap", de: ["Günstiges Taxi Flughafen Zürich {c}", "guenstiges-taxi-flughafen-zuerich-{s}"], en: ["Cheap Taxi Zurich Airport {c}", "cheap-taxi-zurich-airport-{s}"], fr: ["Taxi pas cher aéroport Zurich {c}", "taxi-pas-cher-aeroport-zurich-{s}"], it: ["Taxi economico aeroporto Zurigo {c}", "taxi-economico-aeroporto-zurigo-{s}"] },
  { id: "taxi-to", de: ["Taxi nach {c}", "taxi-nach-{s}"], en: ["Taxi to {c}", "taxi-to-{s}"], fr: ["Taxi pour {c}", "taxi-pour-{s}"], it: ["Taxi per {c}", "taxi-per-{s}"] },
  { id: "taxi-c-airport", de: ["Taxi {c} Flughafen", "taxi-{s}-flughafen"], en: ["Taxi {c} Airport", "taxi-{s}-airport"], fr: ["Taxi {c} aéroport", "taxi-{s}-aeroport"], it: ["Taxi {c} aeroporto", "taxi-{s}-aeroporto"] },
  { id: "chauffeur", de: ["Chauffeurservice Zürich {c}", "chauffeurservice-zuerich-{s}"], en: ["Chauffeur Service Zurich {c}", "chauffeur-service-zurich-{s}"], fr: ["Service chauffeur Zurich {c}", "service-chauffeur-zurich-{s}"], it: ["Servizio autista Zurigo {c}", "servizio-autista-zurigo-{s}"] },
];

export const cityName = (city, lang) => (lang === "en" && city.nEn ? city.nEn : city.n);
export const priceOf = (km) => Math.round((80 + km * 2.6) / 5) * 5;
export const minutesOf = (km) => Math.round(km * 0.9) + 15;

const fill = (tpl, c, s) => tpl.replace(/\{c\}/g, c).replace(/\{s\}/g, s);

export const buildPage = (lang, patternId, city) => {
  const p = PATTERNS.find((x) => x.id === patternId);
  if (!p || !p[lang]) return null;
  const c = cityName(city, lang);
  const [kwTpl, slugTpl] = p[lang];
  return {
    lang,
    patternId,
    city,
    keyword: fill(kwTpl, c, city.s),
    slug: fill(slugTpl, c, city.s),
    km: city.km,
    minutes: minutesOf(city.km),
    price: priceOf(city.km),
    image: SEO_IMAGES[city.t] || SEO_IMAGES.city,
    cityDisplay: c,
  };
};

// Reverse lookup maps: { lang: { slug: {patternId, citySlug} } }
const INDEX = {};
LANGS4.forEach((lang) => {
  INDEX[lang] = {};
  CITIES.forEach((city) => {
    PATTERNS.forEach((p) => {
      const [, slugTpl] = p[lang];
      const slug = fill(slugTpl, cityName(city, lang), city.s);
      INDEX[lang][slug] = { patternId: p.id, city };
    });
  });
});

export const resolvePage = (lang, slug) => {
  if (!INDEX[lang]) return null;
  const hit = INDEX[lang][slug];
  if (!hit) return null;
  return buildPage(lang, hit.patternId, hit.city);
};

// Alternate-language URLs for the same (city, pattern) → for hreflang
export const alternates = (patternId, city) =>
  LANGS4.map((lang) => {
    const pg = buildPage(lang, patternId, city);
    return { lang, url: `/${lang}/${pg.slug}` };
  });

export const allPages = () => {
  const out = [];
  LANGS4.forEach((lang) => {
    CITIES.forEach((city) => {
      PATTERNS.forEach((p) => {
        const pg = buildPage(lang, p.id, city);
        out.push({ lang, slug: pg.slug });
      });
    });
  });
  return out;
};

export { CITIES };

export const canonicalOf = (lang, city) => buildPage(lang, "transfer", city);
export const otherCities = (city, n = 12) => {
  const idx = CITIES.findIndex((c) => c.s === city.s);
  const out = [];
  for (let i = 1; i <= n && i < CITIES.length; i++) out.push(CITIES[(idx + i) % CITIES.length]);
  return out;
};
export const variantKeywords = (lang, city) => PATTERNS.map((p) => buildPage(lang, p.id, city).keyword);

// Canonical pages only (one per city per language) — used for sitemap.
export const canonicalPages = () => {
  const out = [];
  LANGS4.forEach((lang) => CITIES.forEach((city) => {
    const pg = buildPage(lang, "transfer", city);
    out.push({ lang, slug: pg.slug });
  }));
  return out;
};
